export default {
    resalesLanding: {
        sentOn: "Wysłano",
        toggleContact: "Pokaż/ukryj dane kontaktowe biura",
        propertyOffers: "Oferty nieruchomości",
        openGallery: "Otwórz galerię zdjęć",
        prevPhoto: "Poprzednie zdjęcie",
        nextPhoto: "Następne zdjęcie",
        close: "Zamknij",
        photo: "Zdjęcie",
        description: "Opis",
        more: "Więcej",
        less: "Mniej",
        intFloorSpace: "Powierzchnia użytkowa",
        build: "Powierzchnia całkowita",
        terrace: "Taras",
        garden: "Ogród",
        buildYear: "Rok budowy",
        fees: "Opłaty",
        communityFees: "Opłaty wspólnoty mieszkaniowej",
        basuraTax: "Opłata za wywóz śmieci (Basura)",
        ibiFees: "IBI (podatek od nieruchomości)",
        securityDeposit: "Kaucja",
        perMonth: "/miesiąc",
        perWeek: "/tydzień",
        disclaimer: "Klauzula informacyjna",
        energyCertificate: "Świadectwo energetyczne",
        pending: "Oczekuje",
        rating: "Klasa",
        presentedBy: "Prezentuje",
        propertyDetails: "Szczegóły nieruchomości",
        reference: "Numer referencyjny",
        referenceShort: "Ref",
        unitUnavailable: "Już niedostępne",
        availableUnits: "Dostępne lokale i ceny",
        availableUnitsShort: "Dostępne lokale",
        unit: "Lokal",
        type: "Typ",
        floors: "Kondygnacje",
        bedrooms: "Sypialnie",
        bathrooms: "Łazienki",
        surfaceArea: "Wewnętrzna",
        price: "Cena",
        status: "Status",
        unitAvailable: "Dostępny",
        unitReserved: "Zarezerwowany",
        unitSold: "Sprzedany",
        seeMore: "Pokaż więcej",
        seeLess: "Pokaż mniej",
        floor: "Piętro",
        storeys: "Liczba kondygnacji",
        keyReady: "Pod klucz",
        touristLicence: "Licencja turystyczna",
        firstOccupationLicence: "Pozwolenie na użytkowanie",
        notKnown: "Brak danych",
        notProvided: "Nie podano",
        yes: "Tak",
        no: "Nie",
        mortgageAvailable: "Możliwy kredyt hipoteczny",
        guaranteedRental: "Gwarantowany najem",
        sellBeforeCompletion: "Cesja umowy przed ukończeniem inwestycji",
        sellBeforeCompletionYes: "Dozwolona",
        sellBeforeCompletionNo: "Niedozwolona",
        sellBeforeCompletionNotProvided: "Nie podano",
        reservation: "Rezerwacja",
        contract: "Umowa",
        construction: "Budowa",
        completion: "Termin oddania",
        co2: "CO2",
        energyConsumption: "Zużycie energii",
        co2PerYear: "kg CO₂/rok",
        kwhPerYear: "kWh/rok",
        features: "Cechy nieruchomości",
        viewDetails: "Zobacz szczegóły",
        hideDetails: "Ukryj szczegóły nieruchomości",
        backToResults: "Wyniki",
        viewProperty: "Zobacz nieruchomość",
        prevProperty: "Poprzednia",
        nextProperty: "Następna",
        viewAllFeatures: "Zobacz wszystkie cechy nieruchomości",
        allFeatures: "Wszystkie udogodnienia",
        infoOnRequest: "Informacje na życzenie",
        tbc: "d.p.",
        featureCategoryLabels: { pool: "Basen", views: "Widoki", parking: "Parking", kitchen: "Kuchnia", condition: "Stan", garden: "Ogród" },
        featureQualifierFormat: "{value} {category}",
        location: "Lokalizacja",
        agencyInformation: "Informacje o biurze",
        buyingCosts: "Koszty zakupu",
        propertyPrice: "Cena nieruchomości:",
        priceNote: "**Cena nie obejmuje podatków ani kosztów zakupu.",
        estimatedPurchaseCosts: "Szacowane koszty zakupu:",
        hide: "Ukryj",
        showBreakdown: "Pokaż zestawienie kosztów zakupu",
        purchaseCostBreakdown: "Zestawienie kosztów zakupu",
        concept: "Pozycja",
        application: "Zapytanie",
        rowTransferTax: "ITP (podatek od czynności cywilnoprawnych, rynek wtórny)",
        rowVat: "VAT (nowe budownictwo)",
        rowVatLand: "VAT",
        vatApplication: "10% (4% dla mieszkań objętych ochroną socjalną)",
        rowStampDuty: "Opłata skarbowa (AJD)",
        rowNotary: "Notariusz",
        rowLandRegistry: "Księgi wieczyste",
        officialTariff: "Taryfa urzędowa",
        costRangeNotePrefix: "*Całkowite koszty kupującego wynoszą zazwyczaj od",
        and: "i",
        ofPurchasePrice: "ceny zakupu.",
        costApproxNote: "*Szacunkowe koszty zakupu mają charakter wyłącznie orientacyjny. Rzeczywiste koszty mogą się różnić w zależności od nieruchomości i sytuacji kupującego. Zalecamy skorzystanie z profesjonalnej porady w celu dokładnego obliczenia.",
        additionalInformation: "Informacje dodatkowe",
        addInfoDocument: "*Skrócony dokument informacyjny dostępny zgodnie z dekretem Andaluzji 218/2005.",
        addInfoNoFees: "*Kupujący nie płaci prowizji biura nieruchomości",
        formHeading: "Chcesz dowiedzieć się więcej o cenach i nieruchomości?",
        firstName: "Imię",
        enterNumber: "Wpisz numer",
        email: "E-mail",
        searchCountry: "Szukaj kraju lub numeru kierunkowego",
        noMatches: "Brak wyników",
        consent: "Klikając przycisk, wyrażasz zgodę na przetwarzanie swoich danych osobowych zgodnie z polityką prywatności, w tym na gromadzenie, przechowywanie i wykorzystywanie podanych informacji w celu skontaktowania się z Tobą i przekazania niezbędnych informacji.",
        send: "Wyślij",
        contactUs: "Skontaktuj się z nami",
        yourMessage: "Twoja wiadomość",
        agreeData: "Wyrażam zgodę na podanie moich danych w celu otrzymania odpowiedzi na moje zapytanie.",
        agreeContact: "Proszę o informacje i wyrażam zgodę na kontakt ze strony firmy odpowiedzialnej za inwestycję lub właściwego sprzedawcy, za pośrednictwem moich danych kontaktowych, które dobrowolnie podaję w tym celu.",
        reject: "Odrzuć",
        like: "Lubię to",
        liked: "Zapisane",
        rejected: "Odrzucone",
        offerRejected: "Oferta odrzucona",
        contact: "Kontakt",
        call: "Zadzwoń",
        calling: "Trwa połączenie...",
        noPhone: "Brak dostępnego numeru telefonu",
        enquirySent: "Zapytanie zostało wysłane. Wkrótce się z Tobą skontaktujemy.",
        yourDetails: "Twoje dane",
        respondedTo: "odpowiedziano",
        noProperties: "Brak nieruchomości do wyświetlenia.",
        soldOutBody: "Nieruchomości z tej oferty zostały sprzedane lub nie są już dostępne na rynku. Skontaktuj się z agencją, aby otrzymać zaktualizowaną ofertę.",
        expiredTitle: "Ten link do oferty wygasł",
        expiredBody: "Skontaktuj się z biurem, aby otrzymać aktualny link do tych nieruchomości.",
        unavailableTitle: "Oferta niedostępna",
        unavailableBody: "Nie udało się wczytać tej oferty. Link może być nieprawidłowy lub usługa jest tymczasowo niedostępna — spróbuj ponownie później lub skontaktuj się z biurem.",
    },
    title: "Nieruchomości agencji {agencyName}",
    in: "w",
    propertiesFound: "znalezione nieruchomości",
    toDay: "Dzisiaj",
    days: "dni",
    week: "Tydzień",
    year: "Rok",
    month: "Miesiąc",
    prev: "Poprzedni",
    next: "Następna",
    backToList: "Powrót do listy",
    sorry: "Przepraszamy,",
    cantFind: "nie znaleziono",
    lookingFor: "Strona, której szukasz…",
    thankYou: "DZIĘKUJEMY ZA ODWIEDZENIE NASZEJ STRONY INTERNETOWEJ",
    pleaseContact: "Skontaktuj się z agentem, aby otrzymać nowy link.",
    ForSale: "SPRZEDAŻ",
    ShortTermRental: "wynajem krótkoterminowy",
    LongTermRental: "wynajem długoterminowy",
    showMore: "Pokaż więcej",
    showLess: "Pokaż mniej",
    price: "Cena",
    pricePer: "Cena za",
    built: "Powierzchnia całkowita",
    floorSpace: "Powierzchnia użytkowa",
    terrace: "Taras",
    garden: "Ogród",
    plot: "Działka",
    propTitle: '{subType} {searchType} w {location}',
    propTitleShort: '{subType} w {location}',
    notAvailable: "Niedostępne",
    notFound: 'Nie znaleziono strony',
    emptyProperties: "Nie znaleziono żadnych nieruchomości. Skontaktuj się z naszym agentem, aby uzyskać więcej informacji.",
    linkExpired: "Ten link wygasł. Skontaktuj się ze swoim agentem nieruchomości, aby otrzymać nowy link do oferty.",
    newDevelopment: "Nowa inwestycja",
    agencyRaiiNo: "Numer rejestracyjny agencji",
    home: {
        verifyYourURLHere: "Zweryfikuj tutaj swój adres URL. Aby to zrobić, zaloguj się do WhatsApp Web, a następnie skopiuj i wklej tutaj adres URL z WhatsApp.",
        pasteUrlHere: "Wklej tutaj adres URL",
        verifyUrl: "Zweryfikuj adres URL",
        whatIsPropertyViewer: "Czym jest Property-Viewer.com?",
        thisIsWebsiteIsUsed: "Ta strona służy agentom nieruchomości do udostępniania ofert swoim klientom. Jest produktem {resalesonlinecom}. W razie pytań skontaktuj się z agentem, który przesłał Ci tę listę nieruchomości.",
        howDoesItWork: "Jak to działa?",
        inThePast: "W przeszłości agenci nieruchomości wysyłali klientom oferty w formacie PDF. Nie zawsze były one jednak wygodne do przeglądania na różnych urządzeniach. Dlatego stworzyliśmy serwis {propertyviewercom}, który umożliwia wygodne przeglądanie ofert nieruchomości udostępnionych przez agenta.",
        createAShortList: "Agent przygotuje listę wybranych nieruchomości. Po jej udostępnieniu otrzymasz link do przeglądania ofert."
    },

    searchType: {
        ForSale: "na sprzedaż",
        ShortTermRental: "na wynajem krótkoterminowy",
        LongTermRental: "na wynajem długoterminowy",
    },

    rsStatus: {
        Available: "Dostępny",
        Listing: "Oferta",
        UnderOffer: "Oferta przyjęta",
        SaleAgreed: "Sprzedaż uzgodniona",
        OffMarket: "Poza rynkiem",
        Sold: "Sprzedany",
        Rented: "Wynajmowane"
    },

    list: {
        propertyTitle: "Kliknij tutaj, aby wyświetlić informacje o tej nieruchomości."
    },

    details: {
        average: "Średnia",
        averagePricesFor: "Średnie ceny za",
        showFullER: "Pokaż więcej",
        thisProperty: "Ta nieruchomość",
        infoNotAvailable: "Ta informacja jest niedostępna.",
        feesEnergyRating: "Opłaty, Ocena zużycia energii",
        fees: "Opłaty",
        ibiFees: "Opłaty IBI",
        basuraTax: "opłata za wywóz śmieci",
        communityFees: "Opłaty wspólnotowe",
        associatedCosts: "koszty dodatkowe",
        energyRating: "Klasa energetyczna",
        securityDeposit: "Kaucja",
        energyCertificate: "Certyfikat energetyczny",
        energyCertificatePending: "Świadectwo energetyczne w trakcie uzyskania",
        energyConsumption: "Zużycie energii",
        co2: "CO₂",
        co2PerYear: "kg CO₂/m²/rok",
        kwhPerYear: "kWh/m²/rok",
        other: "Pozostałe informacje",
        buildYear: "Rok budowy",
        forSale: "Na sprzedaż",
        sold: "Sprzedane",
        longTerm: "Długoterminowy",
        shortTermHigh: "Sezon wysoki",
        shortTermLow: "Sezon niski",
        allFeatures: "wszystkie parametry",
        aproxLocation: "Przybliżona lokalizacja",
        listingAgent: "Agent prowadzący",
        notIncludeExpensesAndTaxes: "Cena nie obejmuje kosztów ani podatków. Dodatkowe koszty ponoszone przez kupującego obejmują: w przypadku zakupu nowej nieruchomości (pierwszego przeniesienia własności) – podatek od wartości dodanej (VAT/IVA) w wysokości 10% (lub 4% w przypadku mieszkań objętych ochroną socjalną); natomiast w przypadku drugiego i kolejnych przeniesień własności – podatek od przeniesienia własności (ITP), zgodnie z przepisami obowiązującymi w danej wspólnocie autonomicznej. Ponadto zawarcie umowy sprzedaży w formie aktu notarialnego może podlegać podatkowi od czynności prawnych (AJD – Actos Jurídicos Documentados), zgodnie z obowiązującymi przepisami, a także wiązać się z kosztami wpisu do Rejestru Nieruchomości oraz opłatami notarialnymi. Informacje przedumowne są dostępne zgodnie z przepisami obowiązującymi w odpowiedniej wspólnocie autonomicznej.",
        rentalLicenseRef: "Numer licencji turystycznej",
        agencyInformation: "Informacje o agencji",
    },
};